/** Verified artwork and non-destructive JPEG social derivatives, September 14, 2026. */
export type ArticleSocialImageInput = { id: string; imagePath?: string; imageAlt?: string; headline?: string; imageContentType?: string; imageWidth?: number; imageHeight?: number }
export const ARTICLE_SOCIAL_IMAGES: Record<string, { path: string; sourceType: 'image/jpeg' | 'image/png' | 'image/webp'; sourceWidth: number; sourceHeight: number }> = {
  "/editorial/category-fallbacks/ai-compute.webp": {
    "path": "/editorial/social/e8b94befcd73d66b3491-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 864
  },
  "/editorial/category-fallbacks/government.webp": {
    "path": "/editorial/social/73598c77ff33810fb996-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 864
  },
  "/editorial/category-fallbacks/data-centers.webp": {
    "path": "/editorial/social/2d29d4b336df69ec0d76-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 864
  },
  "/editorial/category-fallbacks/robotics-system.webp": {
    "path": "/editorial/social/4a902c23f35535ce3901-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 864
  },
  "/editorial/category-fallbacks/communities.webp": {
    "path": "/editorial/social/df52d7388445bf9c6ac8-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 864
  },
  "/editorial/category-fallbacks/capital.webp": {
    "path": "/editorial/social/2e922d4188eab3b5e560-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 864
  },
  "omikinaArticleImages/0f059a6b007ea62ac9c7": {
    "path": "/editorial/social/d9b115c616f90b0b6295-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1600,
    "sourceHeight": 900
  },
  "/editorial/2026-09-02/clarapetra-pretty-machine-living-world-1200x630.webp": {
    "path": "/editorial/social/9fd7593bca953a7d3141-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-09-01/ai-news-source-reporters-synthesis-1200x630.webp": {
    "path": "/editorial/social/97a09db1f2a1ce93c522-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-09-01/cyber-patch-window-financial-stability-1200x630.webp": {
    "path": "/editorial/social/9855f476239327d91a16-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-09-01/robot-dexterity-wrist-1200x630.webp": {
    "path": "/editorial/social/b40ac5dc0b857eb66a71-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-09-01/ai-token-tax-worker-meter-1200x630.webp": {
    "path": "/editorial/social/af947cc8619006585447-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-31/multidisciplinary-agent-team-1200x630.webp": {
    "path": "/editorial/social/9eb4805db4fb6fa21fa9-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-31/ai-permission-era-1200x630.webp": {
    "path": "/editorial/social/1e7ea96785ba8a01185a-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-31/china-ai-chip-earnings-test-1200x630.webp": {
    "path": "/editorial/social/6cdb159aa4e83302b0fb-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-31/anthropic-music-data-lineage-1200x630.webp": {
    "path": "/editorial/social/e316bb78053c21f12ff9-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-30/omikina-global-cybersecurity-desk.webp": {
    "path": "/editorial/social/659ab41da1015aed8139-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-30/agent-sandbox-failure-1200x630.webp": {
    "path": "/editorial/social/458e6f41eb6bf692bc84-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-28/ai-improves-ai-alignment-loop-1200x630.webp": {
    "path": "/editorial/social/1abbfc5cfad3613744df-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-28/omikina-robot-news-desk.webp": {
    "path": "/editorial/social/588f9dfdc1ef8438a5f6-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-28/ai-cyber-defense-window.webp": {
    "path": "/editorial/social/236731d72be2b2bcb89c-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1536,
    "sourceHeight": 1024
  },
  "/editorial/2026-08-27/cloud-thermal-resilience-watch.webp": {
    "path": "/editorial/social/60a2fc7c3ba41fc8cbc4-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1200,
    "sourceHeight": 630
  },
  "/editorial/2026-08-27/omikina-intelligence-desk.webp": {
    "path": "/editorial/social/feac63e90a8ec4681378-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1600,
    "sourceHeight": 836
  },
  "/editorial/2026-08-22/omikina-platform-update.webp": {
    "path": "/editorial/social/ed76ca9773155bb77e72-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1599,
    "sourceHeight": 900
  },
  "/editorial/2026-08-22/openai.webp": {
    "path": "/editorial/social/a27e0e19e3c757eaae67-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/anthropic.webp": {
    "path": "/editorial/social/b7bbe4a6f130017135ab-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/meta.webp": {
    "path": "/editorial/social/54e9fe6330c2edc35839-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/xai.webp": {
    "path": "/editorial/social/2bc86c7a2319f898176b-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/microsoft.webp": {
    "path": "/editorial/social/a7d7dfd1e42c552b37f3-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/amazon.webp": {
    "path": "/editorial/social/011f30b3dcea0a87b3d2-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/nvidia.webp": {
    "path": "/editorial/social/546e19156ae73f2826d8-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/oracle.webp": {
    "path": "/editorial/social/7c3f75962d7120143fbb-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/alibaba.webp": {
    "path": "/editorial/social/3a6e6891b2bb1a8936e5-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/deepseek.webp": {
    "path": "/editorial/social/7492f137347740540781-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/baidu.webp": {
    "path": "/editorial/social/43bea198ecfd7b592855-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/tencent.webp": {
    "path": "/editorial/social/de40389be6aa6dcab120-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/bytedance.webp": {
    "path": "/editorial/social/2f8af92b888beb42306b-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  },
  "/editorial/2026-08-22/huawei.webp": {
    "path": "/editorial/social/ba05c730700b7f02fab4-1200x630.jpg",
    "sourceType": "image/webp",
    "sourceWidth": 1439,
    "sourceHeight": 810
  }
}

export function resolveArticleSocialCard(article: ArticleSocialImageInput, siteUrl = 'https://www.omikina.com') {
  const base = siteUrl.replace(/\/$/, '')
  const derivative = ARTICLE_SOCIAL_IMAGES[article.imagePath ?? '']
  const alt = article.imageAlt?.trim() || `Editorial illustration for ${article.headline || 'this OMIKINA article'}`
  if (derivative) return { url: `${base}${derivative.path}`, alt, type: 'image/jpeg', width: 1200, height: 630 }
  const local = /^\/editorial\/[a-z0-9][a-z0-9/_-]*\.(?:jpe?g|png|webp)$/i.test(article.imagePath ?? '')
  const stored = /^(?:articleImages|omikinaArticleImages|runtimeCache)\/[a-z0-9][a-z0-9/_-]*$/i.test(article.imagePath ?? '')
  if (!local && !stored) return { url: `${base}/social/omikina-x-share-v3.png`, alt: 'OMIKINA source-linked editorial', type: 'image/png', width: 1200, height: 630 }
  const url = local ? `${base}${article.imagePath}` : `${base}/api/ai-article-image?id=${encodeURIComponent(article.id)}`
  const type = ['image/jpeg', 'image/png', 'image/webp'].includes(article.imageContentType ?? '') ? article.imageContentType
    : local ? (/\.png$/i.test(article.imagePath!) ? 'image/png' : /\.jpe?g$/i.test(article.imagePath!) ? 'image/jpeg' : 'image/webp') : undefined
  const valid = (value?: number) => typeof value === 'number' && Number.isInteger(value) && value > 0
  return { url, alt, type, ...(valid(article.imageWidth) && valid(article.imageHeight) ? { width: article.imageWidth, height: article.imageHeight } : {}) }
}
